<template>
    <div>
        <card :title="hideTitle ? '' : 'Pharmacist Record Page'">
            <SearchComponent v-if="!newMode" v-model="pharmacistDetail" :search-u-r-l="`/StoredPharmacist`"
                :params="{ showOnlyActive: false }" :id="pharmacistDetail && pharmacistDetail.id"
                @input="onPharmacistChange">
            </SearchComponent>
            <b-row>
                <b-col>
                    <checkbox v-model="pharmacistDetail.isActive" block>
                        Is Pharmacist active?
                    </checkbox>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <fg-input v-model="pharmacistDetail.firstName" label="First Name" required></fg-input>
                </b-col>

                <b-col>
                    <fg-input v-model="pharmacistDetail.lastName" label="Last Name" required></fg-input>
                </b-col>
            </b-row>

            <NewClearSaveButtons :disable-save="false" :titles="buttonTitles" @clear-clicked="clearForm"
                @new-clicked="createStoredPharmacist" @save-clicked="saveStoredPharmacist"
                @cancel-clicked="$emit('close')" />
        </card>
    </div>
</template>

<script lang="ts">

import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SearchComponent from '@/components/SearchComponent.vue';
import NewClearSaveButtons, { NewClearSaveTitles } from '@/components/NewClearSaveButtons.vue';
import { PharmacistRecord } from "@/models/Pharmacist"
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import Checkbox from "@/components/Inputs/Checkbox.vue";

@Component({
    name: 'PharmacistDetailPage',
    components: {
        SearchComponent,
        NewClearSaveButtons,
        Checkbox
    }
})

export default class PharmacistDetailPage extends Vue {

    private pharmacistDetail: PharmacistRecord = new PharmacistRecord();

    @Prop({ type: Boolean, default: false }) private newMode!: boolean;
    @Prop({ type: Number, default: 0 }) private pharmacyId!: number;
    @Prop({ default: false }) private hideTitle!: boolean;
    @Prop({ default: false }) private defaultToActive!: boolean;

    created() {
        this.pharmacistDetail.isActive = this.defaultToActive;
    }

    onPharmacistChange(_value: PharmacistRecord) {
        if (!this.pharmacistDetail?.id) return;
        axios.get<PharmacistRecord>(`/StoredPharmacist/${this.pharmacistDetail.id}`)
            .then(pbmResponse => {
                this.pharmacistDetail = new PharmacistRecord(pbmResponse.data);
            }).catch(err => this.$notification(NotificationOptions.error(err)));
    }

    get disableFields(): boolean | null {
        return (this.pharmacistDetail?.id || 0) == 0 && !this.newMode;
    }

    protected buttonTitles: NewClearSaveTitles = {
        new: "",
        save: "Save",
        clear: "",
        cancel: "Cancel",
    };

    createStoredPharmacist() {
        this.newMode = true;
        this.pharmacistDetail = new PharmacistRecord();
        this.pharmacistDetail.isActive = true;
    }

    clearForm() {
        this.newMode = false;
        this.pharmacistDetail = new PharmacistRecord();
    }

    saveStoredPharmacist() {
        this.pharmacistDetail.pharmacyId = this.pharmacyId;
        if (this.pharmacistDetail?.id as number) this.pharmacistDetail.id = this.pharmacistDetail.id as number;
        else this.pharmacistDetail.id = null as unknown as number;

        axios.post<PharmacistRecord>('/StoredPharmacist', this.pharmacistDetail)
            .then(response => {
                if (response.data.id) {
                    this.pharmacistDetail = Object.assign(new PharmacistRecord(), response.data);
                    this.$notification(NotificationOptions.successSaveNotificationPreset("Pharmacist"));
                    this.$emit('created', this.pharmacistDetail);
                }
            })
            .catch(error => {
                this.$notification(NotificationOptions.errorSaveNotificationPreset("Pharmacist", error));
            });
    }

}

</script>

<style scoped>
.form-check {
    margin-top: 0;
    padding-left: 0;
}
</style>
